import { Trans, useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Link, PageTitle } from '@app/core';
import { Theme } from '@app/theme';
import { LargePanePage, UniversalLoginForm } from '@app/auth';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import ShowPhoneBg from '@app/illu/Image/ShowPhoneBg.svg';

const useStyles = createUseStyles((theme: Theme) => ({
  h1: {
    ...theme.fonts.h3,
    marginBottom: theme.marginBase * 2,
  },
  illustration: {
    width: '100%',
    maxWidth: 590,
    margin: theme.marginBase * 3,
  },
  link: {
    ...theme.fonts.label,
    color: theme.colors.blueAccessible,
  },
  recruitNowBlock: {
    ...theme.fonts.caption,
    marginTop: theme.marginBase * 5,
    '& > p': {
      marginBottom: theme.marginBase,
    },
  },
}));

export const Login = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <AnalyticsCategoryProvider category={Categories.LOGIN}>
      <LargePanePage
        color="green"
        panelContent={
          <img
            alt="illustration"
            className={classes.illustration}
            src={ShowPhoneBg}
          />
        }
      >
        <PageTitle title={t('login.metaTitle')} />
        <h1 className={classes.h1}>
          <Trans i18nKey="login.title" />
        </h1>
        <UniversalLoginForm redirectUrl="/" />
        <div className={classes.recruitNowBlock}>
          <p>
            <Trans i18nKey="login.recruitNow" />
          </p>
          <p>
            <Link
              to="/recruit-participants"
              className={classes.link}
              arrowRight
            >
              <Trans i18nKey="login.recruitLink" />
            </Link>
          </p>
        </div>
      </LargePanePage>
    </AnalyticsCategoryProvider>
  );
};
